import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store';
import ConfirmPopup from '../../components/user-roles/confirm-popup/confirm-popup';
import { getUsersWithPerm, resetConfirmState } from './store/slices/confirm';
import { ColumnWithConfirmTypes } from './types';

const ColumnWithConfirmHOC = ({
  children,
  onSubmit,
  onCancel,
  editIsLoading,
  globalError,
}: ColumnWithConfirmTypes): React.JSX.Element => {
  const dispatch = useAppDispatch();

  const {
    confirm: {
      isLoading,
      // usersWithCustomPerms,
      // usersWithDefaultPerms,
      popupIsOpen,
    },
  } = useAppSelector((state) => state.userRoles);

  useEffect(() => {
    dispatch(getUsersWithPerm());

    return () => {
      dispatch(resetConfirmState());
    };
  }, [dispatch]);

  return (
    <>
      {children}
      {popupIsOpen && (
        <ConfirmPopup
          // usersWithCustomPerms={usersWithCustomPerms}
          // usersWithDefaultPerms={usersWithDefaultPerms}
          isLoading={isLoading}
          onSubmit={onSubmit}
          onCancel={onCancel}
          globalError={globalError}
          editIsLoading={editIsLoading}
        />
      )}
      <div id="archive-popup" />
    </>
  );
};

export default ColumnWithConfirmHOC;
